import { Category } from '@sapientpro/sapientpro-data-models';
import CategoryBlock from './CategoryBlock';

const CategoriesSection = ({ categories }: { categories: Category[] }) => (
  <section>
    {categories.map((category, index) => (
      <CategoryBlock
        key={category.slug}
        category={category}
        index={index}
      />
    ))}
  </section>
);

export default CategoriesSection;
